import axios from 'axios';

export default {

    getWishList (page, pageSize,) {
        return axios.get('/api/wishlist/get' , { params: { page: page, pageSize: pageSize}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    removeWishListByItemVariant (page, pageSize,itemVariantId) {
        return axios.get('/api/wishlist/remove/item' , { params: { page: page, pageSize: pageSize , itemVariantId:itemVariantId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    addToWishlist (itemVariantId) {
        return axios.post('/api/wishlist/add/' + itemVariantId )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    removeWishListByItem (itemId) {
        return axios.get('/api/wishlist/remove-by-item' , { params: { itemId:itemId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },
}